import { Phone, ArrowRight, User, MapPin, Bug, MessageSquare, Mail } from "lucide-react";
import { SITE } from "@/config/site";

// Formulaire HTML natif via FormSubmit (aucun JavaScript d'envoi, aucun backend).
// La soumission part directement vers FormSubmit qui redirige ensuite vers /merci.
const NUISIBLES = ["Frelons", "Guêpes", "Rats", "Souris", "Autre", "Je ne sais pas"];

const inputCls =
  "w-full min-h-[48px] px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-brand-black placeholder:text-gray-400 focus:border-brand-gold focus:outline-none transition-colors";

export const ContactForm = () => {
  return (
    <form
      action="https://formsubmit.co/destructionteilleul@gmail.com"
      method="POST"
      data-testid="intervention-form"
      className="bg-white rounded-3xl border border-gray-100 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.15)] p-6 md:p-8 space-y-5"
    >
      <input type="hidden" name="_subject" value="Nouvelle demande d'intervention FRELONS50" />
      <input type="hidden" name="_template" value="table" />
      <input type="hidden" name="_next" value={`${SITE.url}/merci`} />

      <div>
        <label htmlFor="prenom" className="flex items-center gap-2 text-sm font-semibold text-brand-black mb-2">
          <User className="w-4 h-4 text-brand-gold" /> Prénom *
        </label>
        <input id="prenom" type="text" name="Prénom" data-testid="field-prenom" autoComplete="given-name" required className={inputCls} placeholder="Votre prénom" />
      </div>

      <div>
        <label htmlFor="telephone" className="flex items-center gap-2 text-sm font-semibold text-brand-black mb-2">
          <Phone className="w-4 h-4 text-brand-gold" /> Téléphone *
        </label>
        <input id="telephone" type="tel" name="Téléphone" data-testid="field-telephone" autoComplete="tel" inputMode="tel" required className={inputCls} placeholder="06 12 34 56 78" />
      </div>

      <div>
        <label htmlFor="commune" className="flex items-center gap-2 text-sm font-semibold text-brand-black mb-2">
          <MapPin className="w-4 h-4 text-brand-gold" /> Commune *
        </label>
        <input id="commune" type="text" name="Commune" data-testid="field-commune" autoComplete="address-level2" required className={inputCls} placeholder="Le Teilleul" />
      </div>

      <div>
        <label htmlFor="nuisible" className="flex items-center gap-2 text-sm font-semibold text-brand-black mb-2">
          <Bug className="w-4 h-4 text-brand-gold" /> Type de nuisible *
        </label>
        <select id="nuisible" name="Type de nuisible" data-testid="field-nuisible" required className={`${inputCls} cursor-pointer appearance-none bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22none%22 stroke=%22%235B6168%22 stroke-width=%222%22 viewBox=%220 0 24 24%22><path d=%22M6 9l6 6 6-6%22/></svg>')] bg-no-repeat bg-[right_1rem_center] bg-[length:1.25rem] pr-10`}>
          <option value="">Sélectionnez une option</option>
          {NUISIBLES.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="email" className="flex items-center gap-2 text-sm font-semibold text-brand-black mb-2">
          <Mail className="w-4 h-4 text-brand-gold" /> E-mail (facultatif)
        </label>
        <input id="email" type="email" name="email" data-testid="field-email" autoComplete="email" className={inputCls} placeholder="vous@exemple.fr — pour être recontacté par e-mail" />
      </div>

      <div>
        <label htmlFor="message" className="flex items-center gap-2 text-sm font-semibold text-brand-black mb-2">
          <MessageSquare className="w-4 h-4 text-brand-gold" /> Décrivez la situation *
        </label>
        <textarea id="message" name="Message" data-testid="field-message" rows={5} required className={inputCls} placeholder="Emplacement, urgence… Ne vous approchez pas du nid." />
      </div>

      <button
        type="submit"
        data-testid="form-submit-btn"
        className="w-full inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-brand-gold text-brand-black font-bold hover:-translate-y-0.5 transition-transform"
      >
        Envoyer ma demande <ArrowRight className="w-5 h-5" />
      </button>
      <p className="text-xs text-brand-text text-center">
        En envoyant ce formulaire, vous acceptez notre{" "}
        <a href="/politique-confidentialite" className="underline font-semibold text-brand-black">politique de confidentialité</a>.
      </p>
    </form>
  );
};
